/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import { connect } from 'react-redux';
import Select from 'react-select';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import EmptyFileDownloader from '../../components/EmptyFileDownloader';
import { PersonalDataContainer } from '../../containers';
import CustomizedMap from './CustomizedMap';
import history from '../../core/history';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import { DecisionContainer } from '../../containers';
import _ from 'lodash';
import fetch from '../../core/fetch';

import v from './validators';


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const LocationTypeDict = {
  osiedle: {
    label: 'Osiedle',
    editable: true,
  },
  ulica: {
    label: 'Najbliższa ulica',
    editable: true,
  },
  wlasnosc: {
    label: 'Własność lasy (nadleśnictwo, las prywatny):',
    editable: true,
  },
  charakterystyka: {
    label: 'Krótka charakterystyka otoczenia pomnika',
    editable: true,
    type: 'textarea'
  },
};

const ObjectTypeDict = {
  przedmiot: {
    label: 'Przedmiot ochrony',
    editable: true,
  },
  nazwa: {
    label: 'Nazwa projektowanego pomnika (proponowana lub istniejąca historycznie)',
    editable: true,
  },
}

const DescriptionTypeDict = {
  gatunek: {
    label: 'Gatunek',
    editable: true,
  },
  piersnica: {
    label: 'Obwód pierśnicy w cm (130 cm od ziemi)',
    editable: true,
  },
  piersnica2: {
    label: 'Pierśnica w cm (130 cm od ziemi)',
    editable: true,
  },
  wysokosc: {
    label: 'Wysokość [m]',
    editable: true,
  },
  konar: {
    label: 'Wysokość do pierwszego konaru [m]',
    editable: true,
  },
  stan: {
    label: 'Stan zdrowotny i zauważone uszkodzenia',
    editable: true,
  },
  zabiegi: {
    label: 'Wymagane zabiegi ochronne',
    editable: true,
  },
  uzasadnienie: {
    label: 'Uzasadnienie wniosku',
    editable: true,
    type: 'textarea'
  },
}


class WniosekPomnikprzyrody extends React.Component {
  state = {
    lokalizacja: {
      osiedle: '',
      ulica: '',
      wlasnosc: '',
      charakterystyka: ''
    },
    obiekt: {
      przedmiot: '',
      nazwa: '',
    },
    opis: {
      gatunek: '',
      piersnica: '',
      piersnica2: '',
      wysokosc: '',
      konar: '',
      stan: '',
      zabiegi: '',
      uzasadnienie: '',
    },
    selectedParcels: [],
    selectedRoads: [],
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    districtEservice: null
  };

  elseString = '.....................';
  spanStyle = {
    color: 'red',
  };

  validators = {
    osiedle: [v.NotNull],
    ulica: [v.NotNull],
    wlasnosc: [v.NotNull],
    charakterystyka: [v.NotNull],
    przedmiot: [v.NotNull],
    nazwa: [v.NotNull],
    gatunek: [v.NotNull],
    piersnica: [v.NotNull],
    piersnica2: [v.NotNull],
    wysokosc: [v.NotNull],
    konar: [v.NotNull],
    stan: [v.NotNull],
    zabiegi: [v.NotNull],
    uzasadnienie: [v.NotNull],
  };

  nextStep = '/eservices/eserviceSummary/';

  onHide = () => this.setState({ showError: false });

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });
  setRoads = (roads, callback = null) => this.setState({ selectedRoads: roads });

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  componentWillMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp
        })
      })
  }

  insertTestData = () => {
    this.setState({
      lokalizacja: {
        osiedle: 'Kwiatowe',
        ulica: 'Piekna',
        wlasnosc: 'panstwowy',
        charakterystyka: 'nie wiem'
      },
      obiekt: {
        przedmiot: 'drzewo',
        nazwa: 'dab',
      },
      opis: {
        gatunek: 'dab',
        piersnica: '12',
        piersnica2: '42',
        wysokosc: '35',
        konar: '35',
        stan: 'idealny',
        zabiegi: 'brak',
        uzasadnienie: 'bo chce',
      }
    })
  }

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['obiekt', 'lokalizacja', 'opis'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (this.state.selectedParcels.length === 0) {
      this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
      });
      return;
    }

    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true
      });
      return;
    }

    if (!hasFieldErrors && this.state.selectedParcels.length > 0) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          mpzpOwner: { ...this.state.mpzpOwner },
          obiekt: { ...this.state.obiekt },
          lokalizacja: { ...this.state.lokalizacja },
          opis: { ...this.state.opis },
          dzialki: this.state.selectedParcels,
          selectedParcels: this.state.selectedParcels,
          user: {
            ...this.props.serviceInfo.user,
          },
          shortName: this.props.serviceInfo.eservice.shortName,
          urzad: this.props.districts[this.props.prefix],
        })
        .then(resp => {
          window.location.href = `${this.nextStep}${resp.jobId}`;
        });
    }
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user ? this.props.serviceInfo.user : null} />

        <GrayPanel
          title={'1. Teren'}
        >
          <div className="help-desc">
            W celu wybrania przedmiotowej działki lub działek ewidencyjnych należy wykorzystać jeden z dwóch dostępnych sposobów wyboru działki:<br />
            <ol>
              <li> Wybrać obręb ewidencyjny z rozwijalnej listy obrębów, a następnie wpisać numer działki. W celu dodania kolejnej działki należy powtórzyć czynność.</li>
              <li>Wskazać działkę w oknie mapy wykorzystując przycisk <samp>"Wskaż działki na mapie"</samp>. W celu wybrania kilku działek konieczne jest przytrzymanie na klawiaturze klawisza <kbd>CTRL</kbd>.</li>
            </ol>
            Wybór działek można usunąć pojedynczo lub usuwając wszystkie za pomocą przycisku <samp>"Odznacz wszystko"</samp>.
          </div>
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
          />
        </GrayPanel>

        <DecisionContainer
          title={'2. Lokalizacja obiektu'}
          data={this.state.lokalizacja}
          errors={this.state.errors}
          formDict={LocationTypeDict}
          onChange={e => this.onChange(e, 'lokalizacja')}
        />

        <DecisionContainer
          title={'3. Dane o wnioskowanym obiekcie'}
          data={this.state.obiekt}
          errors={this.state.errors}
          formDict={ObjectTypeDict}
          onChange={e => this.onChange(e, 'obiekt')}
        />

        <DecisionContainer
          title={'4. Opis pomnika'}
          data={this.state.opis}
          errors={this.state.errors}
          formDict={DescriptionTypeDict}
          onChange={e => this.onChange(e, 'opis')}
        />


        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ progress: 0 }, () => this.startService())}
            >
              Uruchom
            </button>
            {_.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

WniosekPomnikprzyrody.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(WniosekPomnikprzyrody),
);



// WEBPACK FOOTER //
// src/routes/eservices/WniosekPomnikPrzyrody.js